import * as React from "react";

import {
  TabsProps as MUITabsProps,
  Tabs as MUITabs,
  FormLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Tab from "../Tab";

type TabsProp = MUITabsProps &
  (
    | {
        tabs: (string | { label: string; value: string | number })[];
        children?: undefined;
      }
    | { tabs?: undefined }
  );

const Tabs = (props: React.PropsWithChildren<TabsProp>) => {
  const { tabs, children, ...other } = props;
  const { t } = useTranslation();
  if (tabs !== undefined && tabs.length > 1)
    return (
      <MUITabs
        {...other}
        sx={{
          "& *": {
            cursor: "pointer",
          },
          ".Mui-selected > label": {
            color: "text.primary",
          },
        }}
      >
        {tabs.map((s) => {
          const { value, label } =
            typeof s === "string" ? { value: s, label: s } : s;
          return (
            <Tab
              key={value}
              label={<FormLabel>{t(label)}</FormLabel>}
              value={value}
            />
          );
        })}
      </MUITabs>
    );
  return <MUITabs {...other}>{children}</MUITabs>;
};

export default Tabs;
